import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { Progress } from 'antd';
import React from 'react';

interface ProgressOnboardingProps {
  completed: number;
  total: number;
  strokeColor?: string;
  trailColor?: string;
  className?: string;
}

const ProgressOnboarding: React.FC<ProgressOnboardingProps> = ({
  completed,
  total,
  strokeColor = defaultTheme.theme.palette.primary[600],
  trailColor = defaultTheme.theme.palette.primary[75],
  className = '',
}) => {
  const percentage = Math.round((completed / total) * 100);
  const progressText = `${completed}/${total} completed`;

  return (
    <div className={`flex items-center gap-x-4 ${className}`}>
      <div className="text-gray-600 text-sm font-medium">{progressText}</div>

      <Progress
        className="flex-1"
        percent={percentage}
        strokeColor={strokeColor}
        trailColor={trailColor}
        showInfo={false}
        strokeWidth={8}
      />
    </div>
  );
};

export default ProgressOnboarding;
